import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/terms-of-service',
    name: 'TermsOfServicePage',
    component: () => import('@/modules/termsOfService/views/TermsOfServicePage.vue'),
    meta: {
      // Chrome-free layout: the document carries its own masthead, and the terms
      // have to be readable before anyone has an account.
      layout: 'LoginSplitLayout',
      requiresAuth: false,
    },
  })
}
